// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.docs-mobile-nav {
  position: relative;
  z-index: 9;
  background: var(--white);
  width: 100%;
  border-top: 1px solid var(--black1);
  top: auto !important;
}
.docs-mobile-nav.open {
  top: 0 !important;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  position: absolute;
  border-top: none;
}
.docs-mobile-nav.open .docs-mobile-nav-current {
  height: 3.5rem;
  border-bottom: 1px solid var(--black1);
}
.docs-mobile-nav-back svg * {
  stroke: var(--black9) !important;
}
.docs-mobile-nav-current {
  cursor: pointer;
  height: 2.75rem;
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);
  display: flex;
  align-items: center;
  padding: 0 1rem;
  justify-content: space-between;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
.docs-mobile-nav-current svg {
  margin-right: 0.75rem;
}
.docs-mobile-nav-current svg * {
  stroke: var(--purple6);
}
.docs-mobile-nav-body {
  width: 100%;
  height: calc(100% - 3.5rem - 1rem);
  overflow: auto;
  background: var(--white);
  display: none;
  z-index: -1;
  position: relative;
  flex-direction: column;
}
.docs-mobile-nav-list-title {
  padding: 0.75rem 1rem;
  font-weight: 600;
  display: flex;
  color: var(--black5) !important;
  font-family: "Inter";
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  align-items: center;
}
.docs-mobile-nav-list-body {
  display: flex;
  flex-direction: column;
}
.docs-mobile-nav-list-body > a {
  display: flex;
  padding: 0.75rem 1rem;
  color: var(--black5) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  align-items: center;
  margin-left: 1rem;
}
.docs-mobile-nav-list-body > a.sub {
  margin-left: 0;
}
.docs-mobile-nav-list-body > a.subsub {
  margin-left: 0;
}
.docs-mobile-nav-list-body > a svg {
  margin-right: 0.75rem;
}
.docs-mobile-nav-list-body > a:hover {
  text-decoration: none;
  color: var(--black9) !important;
}
.docs-mobile-nav-list-body > a.active {
  color: var(--black9) !important;
}
.docs-mobile-nav-list-body > a.active svg * {
  stroke: var(--purple6);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/docsumentation/mobile-nav/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;EACA,mCAAA;EACA,oBAAA;AACF;AACE;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACE,cAAA;EACA,sCAAA;AACN;AAKM;EACE,gCAAA;AAHR;AAQE;EACE,eAAA;EACA,eAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AANJ;AAQI;EACE,qBAAA;AANN;AAQM;EACE,sBAAA;AANR;AAWE;EACE,WAAA;EACA,kCAAA;EACA,cAAA;EACA,wBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AATJ;AAkBI;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,aAAA;EACA,sBAAA;AAjBN;AAmBM;EACE,aAAA;EACA,qBAAA;EACA,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAjBR;AAmBQ;EACE,cAAA;AAjBV;AAoBQ;EACE,cAAA;AAlBV;AAqBQ;EACE,qBAAA;AAnBV;AAsBQ;EACE,qBAAA;EACA,+BAAA;AApBV;AAuBQ;EACE,+BAAA;AArBV;AAuBU;EACE,sBAAA;AArBZ","sourcesContent":[".docs-mobile-nav {\n  position: relative;\n  z-index: 9;\n  background: var(--white);\n  width: 100%;\n  border-top: 1px solid var(--black1);\n  top: auto !important;\n\n  &.open {\n    top: 0 !important;\n    z-index: 999;\n    width: 100vw;\n    height: 100vh;\n    position: absolute;\n    border-top: none;\n\n    .docs-mobile-nav-current {\n      height: 3.5rem;\n      border-bottom: 1px solid var(--black1);\n    }\n  }\n\n  &-back {\n    svg {\n      * {\n        stroke: var(--black9) !important;\n      }\n    }\n  }\n\n  &-current {\n    cursor: pointer;\n    height: 2.75rem;\n    box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);\n    display: flex;\n    align-items: center;\n    padding: 0 1rem;\n    justify-content: space-between;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    color: var(--black9);\n\n    svg {\n      margin-right: .75rem;\n\n      * {\n        stroke: var(--purple6);\n      }\n    }\n  }\n\n  &-body {\n    width: 100%;\n    height: calc(100% - 3.5rem - 1rem);\n    overflow: auto;\n    background: var(--white);\n    display: none;\n    z-index: -1;\n    position: relative;\n    flex-direction: column;\n  }\n\n  &-close {\n\n  }\n\n  &-list {\n\n    &-title {\n      padding: .75rem 1rem;\n      font-weight: 600;\n      display: flex;\n      color: var(--black5) !important;\n      font-family: 'Inter';\n      font-style: normal;\n      font-size: 14px;\n      line-height: 17px;\n      align-items: center;\n    }\n\n    &-body {\n      display: flex;\n      flex-direction: column;\n\n      & > a {\n        display: flex;\n        padding: .75rem 1rem;\n        color: var(--black5) !important;\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 17px;\n        align-items: center;\n        margin-left: 1rem;\n\n        &.sub {\n          margin-left: 0;\n        }\n        \n        &.subsub {\n          margin-left: 0;\n        }\n\n        svg {\n          margin-right: .75rem;\n        }\n\n        &:hover {\n          text-decoration: none;\n          color: var(--black9) !important;\n        }\n\n        &.active {\n          color: var(--black9) !important;\n\n          svg * {\n            stroke: var(--purple6);\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
